<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-header": "",
        "hide-footer": "",
        id: "take-photos",
        centered: "",
        size: "md",
      },
      on: { hidden: _vm.onModalHidden },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("div", { staticClass: "modal-ui" }, [
        _vm.showVideo || (!_vm.showVideo && !_vm.isValid && !_vm.picture)
          ? _c("div", { staticClass: "rc-modal-title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("" + _vm.Title, {
                      way: _vm.way,
                      document: _vm.documentText,
                    })
                  ) +
                  " "
              ),
            ])
          : _c("div", { staticClass: "rc-modal-title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("WebCam.reviewImage", { document: _vm.documentText })
                  ) +
                  " "
              ),
            ]),
        _c("section", { staticClass: "photo-capture" }, [
          _c(
            "div",
            { staticClass: "take-photo-outer" },
            [
              _c("video", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showVideo,
                    expression: "showVideo",
                  },
                ],
                ref: "player",
                staticClass: "camera",
                attrs: { autoplay: "", playsinline: "" },
              }),
              _c("canvas", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showVideo && _vm.isValid,
                    expression: "!showVideo && isValid",
                  },
                ],
                ref: "canvas",
                staticClass: "camera",
              }),
              _c("b-img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showVideo && !_vm.isValid,
                    expression: "!showVideo && !isValid",
                  },
                ],
                staticClass: "camera",
                attrs: { src: _vm.picture, alt: "Captured Image" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "error-outer" },
            [_c("Errors", { attrs: { error: _vm.isCameraAvailable } })],
            1
          ),
          !_vm.hideBtns
            ? _c(
                "div",
                { staticClass: "camera-outer error-outer" },
                [
                  _c("Errors", { attrs: { error: _vm.error } }),
                  _vm.showVideo ||
                  (!_vm.showVideo && !_vm.isValid && !_vm.picture)
                    ? _c(
                        "b-button",
                        {
                          staticClass: "camera-btn",
                          attrs: {
                            variant: "flat-primary",
                            disabled: !!_vm.isCameraAvailable,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.capture($event)
                            },
                          },
                        },
                        [_c("CameraIcon")],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "submit-button controls" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "outline-secondary" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.cancel($event)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Kyc.Cancel")) + " ")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.done($event)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Kyc.Save")) + " ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("input", {
          ref: "fileInput",
          staticStyle: { display: "none" },
          attrs: { type: "file", accept: "image/*" },
          on: { change: _vm.handleHiddenFileInputChange },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/WebCam.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_js_modules_esnext_typed_array_at_js from 'core-js/modules/esnext.typed-array.at.js';
import core_js_modules_es_typed_array_set_js from 'core-js/modules/es.typed-array.set.js';
import assets_rashi_coin_camera_icon_svg from '@/assets/rashi-coin/camera-icon.svg';
import * as bootstrapvue from 'bootstrap-vue';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  name: "PhotoCapture",
  props: {
    hideBtns: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    showCameraPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    toggleImage: {
      type: Function,
      isRequired: false,
      default: () => {}
    },
    saveImage: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    imageKey: {
      type: String,
      default: ""
    },
    value: {
      default: null
    },
    Title: {
      type: String,
      default: ""
    },
    documentText: {
      type: String,
      default: ""
    }
  },
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BFormFile: bootstrapvue["BFormFile"],
    BImg: bootstrapvue["BImg"],
    CameraIcon: assets_rashi_coin_camera_icon_svg,
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      showVideo: true,
      imageSrc: null,
      isValid: true,
      modalVisible: this.showCameraPop,
      isCameraAvailable: "",
      videoPlayer: null,
      picture: null,
      canvasElement: {
        width: 100,
        height: 100
      },
      document: null,
      error: null,
      way: this.$t("Capture")
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.player) this.videoPlayer = this.$refs.player;
      if (this.$refs.canvas) this.canvasElement = this.$refs.canvas;

      // Check if videoPlayer is defined before attaching the event listener
      if (this.videoPlayer) {
        this.videoPlayer.addEventListener("loadedmetadata", this.handleLoadedMetadata);
      }
      this.streamUserMediaVideo();
    });
  },
  beforeDestroy() {
    if (this.videoPlayer) {
      this.videoPlayer.removeEventListener("loadedmetadata", this.handleLoadedMetadata);
    }
  },
  methods: {
    streamUserMediaVideo() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$nextTick(() => {
          if (this.$refs.fileInput) {
            // If getUserMedia is not supported, open the file input for image picking
            console.error("User media not supported. Opening file input.");
            this.$refs.fileInput.click();
            this.showVideo = false;
            this.showVideo = false;
          }
        });
        return;
      }
      const videoConstraints = {
        video: {
          width: {
            ideal: 1280
          },
          // Set the desired width
          height: {
            ideal: 720
          } // Set the desired height
        }
      };
      navigator.mediaDevices.getUserMedia(videoConstraints).then(stream => {
        if (this.$refs.player) {
          this.videoPlayer = this.$refs.player;
          this.$refs.player.srcObject = stream;
          this.$refs.player.addEventListener("loadedmetadata", this.handleLoadedMetadata);
        }
      }).catch(error => {
        console.error("Error accessing user media:", error);
        this.isValid = false;
        this.isCameraAvailable = "";
        if (error.name === "NotAllowedError") {
          console.error("Camera permission denied");
          this.isCameraAvailable = this.$t("Errors.CameraAvailableError");
        } else {
          if (this.$refs.fileInput) {
            this.showVideo = false;
            this.way = this.$t("Upload");
            // If getUserMedia is not supported, open the file input for image picking
            console.error("Opening file input due to error.");
            this.$refs.fileInput.click();
          }
        }
      });
    },
    onModalHidden() {
      this.stopVideoStream();
      this.toggleImage({
        imageKey: this.imageKey,
        showCameraPop: false
      });
    },
    capture() {
      // Handle capturing logic
      if (!this.isValid) {
        this.$refs.fileInput.click();
      } else {
        this.showVideo = false;
        this.handleLoadedMetadata();
      }
    },
    handleLoadedMetadata() {
      const canvasElement = this.$refs.canvas;
      if (!canvasElement) {
        console.error("Canvas element is not available.");
        return;
      }

      // Ensure the canvas has a valid context
      const context = canvasElement.getContext("2d");
      if (!context) {
        console.error("Unable to get 2D context for canvas.");
        return;
      }

      // Set canvas dimensions
      canvasElement.width = this.videoPlayer.videoWidth;
      canvasElement.height = this.videoPlayer.videoHeight;

      // Draw video frame on the canvas
      context.drawImage(this.videoPlayer, 0, 0, canvasElement.width, canvasElement.height);

      // Stop the video stream
      if (!this.showVideo) this.stopVideoStream();

      // Get the data URL of the canvas
      this.imageSrc = canvasElement.toDataURL();
    },
    done() {
      // Create a Blob from the data URL
      let file = null;
      if (this.isValid) {
        const blob = this.dataURLtoBlob(this.imageSrc);

        // Compress the image if its size exceeds 2MB
        const maxFileSizeMB = 2; // Set the maximum file size in megabytes
        const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024; // Convert megabytes to bytes
        if (blob.size > maxFileSizeBytes) {
          this.compressImage(blob, maxFileSizeBytes, compressedBlob => {
            file = new File([compressedBlob], "captured_image.png", {
              type: "image/png"
            });
            this.saveImage(file, this.imageSrc, this.imageKey);
            this.modalVisible = false;
          });
          return;
        }

        // If the image size is within the limit, directly create a File from the Blob
        file = new File([blob], "captured_image.png", {
          type: "image/png"
        });
      } else if (this.document) {
        this.imageSrc = this.picture;
        file = this.document;
      } else {
        this.error = this.$t("Errors.InvalidImage");
        return;
      }
      this.saveImage(file, this.imageSrc, this.imageKey);
      this.modalVisible = false;
    },
    compressImage(blob, maxSize, callback) {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Convert canvas to Blob
        canvas.toBlob(compressedBlob => {
          if (compressedBlob.size > maxSize) {
            // If compressed size still exceeds the limit, recursively compress again
            this.compressImage(compressedBlob, maxSize, callback);
          } else {
            // If compressed size is within the limit, invoke the callback with the compressed Blob
            callback(compressedBlob);
          }
        }, "image/jpeg", 0.5); // Adjust the quality parameter as needed (0.5 represents 50% quality)
      };
      img.src = URL.createObjectURL(blob);
    },
    dataURLtoBlob(dataURL) {
      const parts = dataURL.split(";base64,");
      const contentType = parts[0].split(":")[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType
      });
    },
    // handleFileInputChange(event) {
    //   const file = event.target.files[0];
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       this.imageSrc = event.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   }
    //   event.target.value = null;
    //   this.showVideo = false;
    // },
    // handleFileSelected() {
    //   if (this.document) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       this.picture = event.target.result;
    //     };
    //     reader.readAsDataURL(this.document);
    //     this.showVideo = false;
    //   }
    // },
    handleHiddenFileInputChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          this.document = file;
          this.picture = e.target.result;
        };
        reader.readAsDataURL(file);
        this.showVideo = false;
      }
    },
    cancel() {
      this.showVideo = true;
      this.streamUserMediaVideo();
    },
    stopVideoStream() {
      if (this.showVideo && this.videoPlayer && this.videoPlayer.srcObject) {
        this.videoPlayer.srcObject.getVideoTracks().forEach(track => {
          track.stop();
        });
        this.showVideo = false;
        return;
      }
      if (!(this.$refs.player && this.$refs.player.srcObject)) return;
      this.$refs.player.srcObject.getVideoTracks().forEach(track => {
        track.stop();
      });
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/WebCam.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.camera {
  width: 100%;
  height: 100%;
}
</style>
